import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Employee } from '../../../../../api/Endpoints/Employee';
import moment from 'moment';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Card,
    CardContent,
    Typography,
    Grid,
    Divider,
    Select,
    MenuItem,
    DialogTitle,
    InputLabel,
    TextareaAutosize,
    TextField,
    Slide,
    CircularProgress,
    Backdrop,
} from "@mui/material";
import { useEffect } from 'react';
import { useState } from 'react';

const useStyles = makeStyles((theme) => ({
    card: {
        margin: theme.spacing(2),
        padding: theme.spacing(2),
        boxShadow: '1px 2px 2px 2px rgba(0, 0, 0, 0.3)',
    },
    title: {
        fontWeight: 'bold',
    },
    divider: {
        margin: theme.spacing(2, 0),
    },
    select: {
        minWidth: 200,
    },
}));

const Details = ({ ID }) => {
    const classes = useStyles();


    const [Loading, setLoading] = useState(false)
    const [Data, setData] = useState()
    console.log(Data)
    useEffect(() => {
        fetchDetails()
    }, [])


    const fetchDetails = async () => {
        setLoading(true);
        setData()
        let EmployeeDetail = await Employee.getEmployeeDetails({ id: ID });
        let data = EmployeeDetail.data.data
        setData(data)
        setLoading(false);
    }

    return (
        <>
            {Loading ? (
                <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={Loading}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            ) : (
                <>
                    <Card className={classes.card}>
                        <CardContent>
                            <Grid container spacing={2}>
                                <Grid item xs={6} sm={6}>
                                    <Typography variant="body1" component="h2" style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                                        Name:
                                        <Typography variant="body2" style={{ display: 'inline', paddingLeft: 10, fontSize: '16px' }}>
                                            {Data?.user?.name}
                                        </Typography>
                                    </Typography>


                                </Grid>
                                <Grid item xs={6} sm={6}>
                                    <Typography variant="body1" component="h2" style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                                        Email:
                                        <Typography variant="body2" style={{ display: 'inline', paddingLeft: 10, fontSize: '16px' }}>
                                            {Data?.user?.email}
                                        </Typography>
                                    </Typography>

                                </Grid>
                            </Grid>
                            <Divider className={classes.divider} />
                            <Grid container spacing={2}>
                                <Grid item xs={6} sm={6}>
                                    <Typography variant="body1" component="h2" style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                                        Phone Number :    <Typography variant="body2" style={{ display: 'inline', paddingTop: 10, fontSize: '16px' }}>
                                            {Data?.phone_number}
                                        </Typography>
                                    </Typography>


                                </Grid>
                                <Grid item xs={6} sm={6}>
                                    <Typography variant="body1" component="h2" style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                                        Department:         <Typography variant="body2" style={{ display: 'inline', paddingTop: 10, fontSize: '16px' }}>
                                            {Data?.department?.name}
                                        </Typography>
                                    </Typography>

                                </Grid>

                            </Grid>
                            <Divider className={classes.divider} />
                            <Grid container spacing={2}>
                                <Grid item xs={6} sm={6}>
                                    <Typography variant="body1" component="h2" style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                                        Joining Date:   <Typography variant="body2" style={{ display: 'inline', paddingTop: 10, fontSize: '16px' }}>
                                            {moment(Data?.joining_date).format('DD/MM/YYYY')}
                                        </Typography>

                                    </Typography>

                                </Grid>
                                <Grid item xs={6} sm={6}>
                                    <Typography variant="body1" component="h2" style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                                        ROLE:   <Typography variant="body2" style={{ display: 'inline', paddingTop: 10, fontSize: '16px' }}>
                                            {Data?.role?.name}
                                        </Typography>
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Divider className={classes.divider} />
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12}>
                                    <Typography variant="body1" component="h2" style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                                        Address:
                                    </Typography>
                                    <Typography variant="body2" style={{ paddingTop: 10, fontSize: '16px' }}>
                                        {Data?.address}
                                    </Typography>

                                </Grid>
                            </Grid>

                            <Divider className={classes.divider} />
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12}>
                                    <Typography variant="body1" component="h2" style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                                        Remarks:
                                    </Typography>
                                    <Typography variant="body2" style={{ paddingTop: 10, fontSize: '16px' }}>
                                        {Data?.remarks}
                                    </Typography>

                                </Grid>
                            </Grid>

                        </CardContent>
                    </Card>
                </>
            )
            }
        </>
    );
};

export default Details;
